module.exports = __webpack_public_path__ + "img/PICT_Web_R.bbff8e56.png";